import { Schema as S } from "effect";

export const PostPartnerScheduleRequestSchema = S.Struct({
  partnerCalendarId: S.String,
});

export type PostPartnerScheduleRequest = S.Schema.Type<
  typeof PostPartnerScheduleRequestSchema
>;
